import { FEATURE_TYPE } from '@/constants/features';
import { UsePointToProjectionResult } from '@/utils/map/usePointToProjection';
import { addAlphaToHexString } from '@/utils/convert/addAlphaToHexString';
import getStyle from '@/components/Map/MapViewer/utils/mapElementsRendering/style/getStyle';
import { Feature } from 'ol';
import Polygon from 'ol/geom/Polygon';
import type { MarkerPolygon } from 'minerva-plugin-api';

export const getMarkerPolygonFeatures = (
  markers: MarkerPolygon[],
  { pointToProjection }: { pointToProjection: UsePointToProjectionResult },
): Feature<Polygon>[] =>
  markers.map(marker => {
    const polygon = new Polygon([marker.points.map(point => pointToProjection(point))]);
    const style = getStyle({
      geometry: polygon,
      fillColor: addAlphaToHexString(marker.fillColor, marker.opacity),
      borderColor: marker.borderColor,
      lineWidth: marker.borderWidth,
    });
    const feature = new Feature<Polygon>({
      geometry: polygon,
      id: marker.id,
      type: FEATURE_TYPE.POLYGON_MARKER,
    });
    feature.setStyle(style);
    return feature;
  });
